const CLIENT_IP_STORAGE_KEY = 'samurai_client_ip';

let cachedIp = null;
let inFlightRequest = null;

const readCachedIp = () => {
  if (cachedIp) {
    return cachedIp;
  }

  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  const stored = window.localStorage.getItem(CLIENT_IP_STORAGE_KEY);
  if (stored) {
    cachedIp = stored;
    return stored;
  }

  return null;
};

const storeIp = (ip) => {
  cachedIp = ip;
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(CLIENT_IP_STORAGE_KEY, ip);
  }
};

export const getClientIp = async () => {
  const cached = readCachedIp();
  if (cached) {
    return cached;
  }

  if (inFlightRequest) {
    return inFlightRequest;
  }

  inFlightRequest = fetch('https://api.ipify.org?format=json', {
    cache: 'no-store',
  })
    .then((response) => {
      if (!response.ok) {
        return null;
      }
      return response.json();
    })
    .then((payload) => {
      const ip = payload?.ip;
      if (typeof ip === 'string' && ip.trim()) {
        const trimmed = ip.trim();
        storeIp(trimmed);
        return trimmed;
      }
      return null;
    })
    .catch(() => null)
    .finally(() => {
      inFlightRequest = null;
    });

  return inFlightRequest;
};
